// src/pages/Accounting/Receipts/components/Dashboard/VelaLede.tsx

import { PALETTE } from "../../constants";

interface VelaLedeProps {
  totalCount: number;
  matchedCount: number;
  needsReviewCount: number;
  onReviewClick: () => void;
}

export function VelaLede({
  totalCount,
  matchedCount,
  needsReviewCount,
  onReviewClick,
}: VelaLedeProps) {
  if (needsReviewCount === 0) return null;

  const needsLabel = needsReviewCount === 1 ? "receipt needs" : "receipts need";

  return (
    <p
      style={{
        fontSize: 14,
        color: PALETTE.ink,
        margin: "0 0 22px",
        display: "flex",
        alignItems: "center",
        gap: 8,
        flexWrap: "wrap",
        fontWeight: 500,
      }}
    >
      <span
        aria-hidden="true"
        style={{
          width: 18,
          height: 18,
          borderRadius: "50%",
          background: PALETTE.vela,
          color: "#fff",
          fontWeight: 700,
          fontSize: 10,
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        V
      </span>
      <span>
        <strong style={{ color: PALETTE.ink, fontWeight: 600 }}>Vela</strong>{" "}
        matched {matchedCount} of {totalCount} receipts this month.{" "}
        {needsReviewCount} {needsLabel} your review.
      </span>
      <button
        type="button"
        onClick={onReviewClick}
        style={{
          background: "transparent",
          border: 0,
          padding: 0,
          color: PALETTE.velaDeep,
          fontWeight: 600,
          fontSize: 14,
          cursor: "pointer",
          marginLeft: 4,
        }}
      >
        Review now &rarr;
      </button>
    </p>
  );
}